import React from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

const NftCollectionSelect = ({
  nftCollections,
  selectedNftCollection,
  handleNftCollectionChange,
  onOpen,
  sx,
}: {
  nftCollections: any[]
  selectedNftCollection: string
  handleNftCollectionChange: (e: SelectChangeEvent<string>) => void
  onOpen?: () => void
  sx?: any
}) => {
  return (
    // <div></div>
    <FormControl fullWidth sx={sx}>
      <InputLabel id="nft-collection-select-label" sx={sx}>
        NFT Collection
      </InputLabel>
      <Select
        labelId="nft-collection-select-label"
        id="nft-collection-select"
        value={nftCollections?.length === 0 ? '' : selectedNftCollection}
        label="Nft Collection"
        onChange={handleNftCollectionChange}
        sx={{ sx }}
        MenuProps={{
          sx,
          PaperProps: {
            style: {
              background: '#181D38',
              color: '#fff',
              fontFamily: 'SpaceGrotesk, sans-serif',
            },
          },
          MenuListProps: {
            sx: {
              '& li:hover': {
                background: 'rgba(255, 255, 255, 0.1)',
              },
            },
          },
        }}
        onOpen={onOpen}>
        {nftCollections?.map((nftCollection: any) => {
          return (
            <MenuItem key={nftCollection?.collection} value={nftCollection?.collection}>
              {nftCollection?.collection}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

export default NftCollectionSelect
